import React, {useEffect } from 'react';
import "../assest/PopUp.css";

const Popup = ({ message, onContinue, onGoToCart, duration, closePopup, isSarrafiyeModal, onConfirm, onCancel }) => {

    useEffect(() => {
        if (!isSarrafiyeModal && duration) {
            const timer = setTimeout(() => {
              onContinue(); 
            }, duration);
        
            
            return () => clearTimeout(timer);
        }
      }, [duration, onContinue, isSarrafiyeModal]);

      const handleOutsideClick = (e) => {
        if (e.target.className === 'popup-overlay') {
          closePopup();
        }
      };
  return (
    
    <div className="popup-overlay" onClick={handleOutsideClick}>
      <div className="popup-content">
        {isSarrafiyeModal ? (
          <>
            <h3>⚠️ Uyarı</h3>
            <p style={{ marginBottom: '20px', fontSize: '16px', lineHeight: '1.5' }}>
              Bu ürünü sepete eklemek istediğinizde mevcut sepetiniz boşaltılacaktır. 
              Devam etmek istediğinizden emin misiniz?
            </p>
            <div className="popup-buttons">
              <button 
                className="continue-btn" 
                onClick={onCancel}
                style={{ backgroundColor: '#6c757d', marginRight: '10px' }}
              >
                İptal
              </button>
              <button 
                className="go-cart-btn" 
                onClick={onConfirm}
                style={{ backgroundColor: '#dc3545' }}
              >
                Evet, Devam Et
              </button>
            </div>
          </>
        ) : (
          <>
            <h3>{message}</h3>
            <div className="popup-buttons">
              <button className="continue-btn" onClick={onContinue}>
                Alışverişe Devam Et
              </button>
              <button className="go-cart-btn" onClick={onGoToCart}>
                Sepete Git
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Popup;